import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';
import { TextLink } from '@/components/text-link';
import { joinSgcmSite } from '@/utils/url/join/public';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const DepreciationModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerDepreciationModal}
    contentClassName={cx(
      styles.containerModelContent,
      styles.hasPaddingBottom,
    )}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      Annual depreciation is the amount the owner loses on the value of the
      vehicle per year based on the assumption that the vehicle is
      deregistered only at the end of its 10-yr COE life-span.
      The value of the car body has not been taken into account.
    </div>
    <div>
      The formula used to derive the figure is as follows:
      {' '}
      <br />
      Depreciation =
      (List Price - Minimum PARF value) ÷ remaining years of COE
    </div>
    <div>
      The minimum Preferential Additional Registration Fee (PARF) values
      a sum of money that the vehicle owner gets for deregistering his
      vehicle at the end of its 10-yr COE. It is a function of the Open
      Market Value (OMV) or Additional Registration Fee (ARF).
      Commercial vehicles and cars with renewed COE have no
      minimum PARF value.
    </div>
    <div className={styles.containerTable}>
      <div className={styles.containerItem} />
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        Cars registered with COEs obtained between March 2002 & February 2008
      </div>
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        Cars registered with COEs obtained between March 2008 & February 2013
      </div>
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        Cars registered with COEs obtained from March 2013 onwards
      </div>
      <div className={styles.containerItem}>
        Minimum PARF value at the end of its 10-yr COE
      </div>
      <div className={styles.containerItem}>55% of OMV or 50% of ARF</div>
      <div className={styles.containerItem}>55% of OMV or 50% of ARF</div>
      <div className={styles.containerItem}>50% of ARF</div>
    </div>
    <div>
      Read more about how to compute the relationship between OMV, ARF,
      and PARF in our
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmSite('/articles/advice/understanding-omv-parf-and-coe-rebates-for-your-car-30522')}`}
        target="_blank"
        text=" Guide to tax structure for new cars and deregistration value" />
    </div>
    <div>The figures displayed are estimated and have been rounded off.</div>
    <br />
  </PlainModal>
);
